import React from 'react'
import PropTypes from 'prop-types'
import { Popconfirm, Icon } from 'antd'

export function TableAction({ onRemove, onEdit, onActive, activeText = 'Activate', isActive = false }) {
  return (
    <span>
      {onRemove && <Popconfirm
        title="Are you sure？"
        icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
        onConfirm={onRemove}
      >
        <a href="javascript:;">Remove</a>
      </Popconfirm>}
      {onEdit && <a href="javascript:;" className="ml3" onClick={onEdit}>Edit</a>}
      {onActive && <Popconfirm
        title="Are you sure？"
        icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
        onConfirm={onActive}
      >
        <a href="#" onClick={(e) => e.preventDefault()}>{isActive ? 'Deactivate' : activeText}</a>
      </Popconfirm>}
    </span>
  )
}

TableAction.propTypes = {
  onRemove: PropTypes.func,
  onEdit: PropTypes.func,
  onActive: PropTypes.func,
  activeText: PropTypes.string,
  isActive: PropTypes.bool,
}
